import shortcutManager from '@/utils/shortcut'

/**
 * 挂上快捷键中心。
 * ScannerCore 不在此自动 start，由 getUserInfo 按 /newCashier 权限启停。
 */
const install = (Vue) => {
  Vue.prototype.$shortcuts = shortcutManager
  console.log('TIPS shortcut manager installed, scan deferred until getUserInfo')
}

export default install
